import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { logOutService } from '../../../utilities/partnerServices';

export const fetchLogOut = createAsyncThunk(
    'sessionExtend', logOutService
)

const initialState = {
    value: [
    ]
}

const logOutSlice = createSlice({
    name: 'fundSpecificLookupSlice',
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(fetchLogOut.pending, (state, action) => {
                // toast.warn("PreQualQuestions pending")
            })
            .addCase(fetchLogOut.fulfilled, (state, action) => {
            })
            .addCase(fetchLogOut.rejected, (state, action) => {
                // toast.error(action.error.message)
            })
    },
})


export default logOutSlice.reducer